import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

const resendClientInvitation = async (contactId: string) => {
  const config: AxiosRequestConfig = {
    url: `/contacts/${contactId}/resend_invitation`,
    params: { contactId },
    method: 'post',
  };

  await axios.request(config);
};

export default resendClientInvitation;
